const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/config/liho/setup.ts';
import { PatAppConfiguration } from 'App/defs/setupDefs';
import textMap from './translations';
import ECheckinForm from 'App/config/liho/eCheckin/ECheckinForm';
import { useECheckinInitialValues } from './eCheckin/initialValues';
import Footer from 'App/config/liho/Footer';

export const configuration: PatAppConfiguration = {
    languages: ['de', 'fr', 'en', 'it'],
    footer: Footer,
    eCheckin: {
        initialValuesHook: useECheckinInitialValues,
        form: ECheckinForm,
    },
    navbarTitle: textMap.navbarTitle,
    welcomeTitle: undefined,
    welcomeText: textMap.welcomeText,
    synedraCardTitle: undefined,
    urls: {
        website: 'https://www.lindenhofgruppe.ch',
        loginHelp: undefined,
    },
    customMetaKatMultipleKeys: {
        Countries: 'Lookup/71221995-e5b8-4b70-9b2f-d3400f9105d3/Children',
        Beruf: 'Lookup/735ae29f-f262-4a4d-8c3a-d5c8b2537474/Children',
        Geschlecht: 'Lookup/2beb0fad-159d-47ac-b82d-df9d8fa8caf1/Children',
        CHWohnort: 'Lookup/486eaa79-a256-4b81-9d7b-952ebf537852/Children',
        Zivilstand: 'Lookup/bf8a306a-1bdf-44b2-b69a-42336764c272/Children',
        YesNo: 'Lookup/2b2773ec-6e30-4150-bfc6-ecc86c6de4c9/Children',
        Beziehung: 'Lookup/12ceba01-0518-4ec4-8b67-36f99f712901/Children',
        Behandlungsgrund: 'Lookup/39a4d3db-af29-4418-a5f6-449eb206c778/Children',
        Versicherung: 'Lookup/cda4192a-a434-42b2-ad5c-ae090e9f185c/Children',
        Klasse: 'Lookup/24a23d19-b2ac-40fc-b5be-988658d1a2c5/Children',
        KlasseOhneCHAllg: 'Lookup/5437d2ca-afa0-4641-8189-bcc018b946eb/Children',
        Religion: 'Lookup/7c304573-d445-4e28-a310-57d4a0113b60/Children',
        Anrede: 'Lookup/38c6ef39-5f9d-4f93-9cea-82ae93f3979c/Children',
        Sprache: 'Lookup/1b00de9b-9745-4b95-abc3-09c1225d01c6/Children',
        YN: 'Lookup/3f41b11a-0ff9-4050-a7a7-ffa23501c3f9/Children',
    },
    customMatomoClientId: 2,
    bookAppointmentInfo: undefined,
    bookAppointmentSlotOffset: {
        amount: 24,
        unit: 'hours',
    },
    surgeryCardHint: { title: textMap.surgeryCardHintTitle, text: textMap.surgeryCardHintText },
    videoCallDisclaimerText: undefined,
    SurgeryCardContactAlert: {
        title: textMap.surgeryCardContactAlertTitle,
        text: textMap.surgeryCardContactAlertText,
    },
    surgeryAppointmentDeadline: {
        dayDifference: 1,
        excludeWeekend: true,
        time: {
            hour: 14,
            minute: 0,
        },
    },
    aiaiBotApiKey: '9e981aed-a8ad-46ef-a23e-fb23fff1183e',
};

export const { customMetaKatMultipleKeys } = configuration;
